'use strict';

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _setPrototypeOf = require('babel-runtime/core-js/object/set-prototype-of');

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = require('material-ui');

var _Radio = require('material-ui/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioSelectable = function (_React$Component) {
  _inherits(RadioSelectable, _React$Component);

  function RadioSelectable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadioSelectable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioSelectable.__proto__ || (0, _getPrototypeOf2.default)(RadioSelectable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadioSelectable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          options = _props.options,
          disabled = _props.disabled,
          input = _props.input;

      return _react2.default.createElement(
        _materialUi.FormGroup,
        { className: classes.container },
        _react2.default.createElement(
          _Radio.RadioGroup,
          {
            'aria-label': input.label,
            name: input.label,
            value: input.value,
            onChange: input.onChange,
            row: true
          },
          options.map(function (opt) {
            return _react2.default.createElement(_materialUi.FormControlLabel, {
              key: opt.value,
              value: opt.value,
              control: _react2.default.createElement(_Radio2.default, {
                disabled: disabled,
                classes: { default: classes.root, checked: classes.checked }
              }),
              label: opt.label,
              className: classes.label
            });
          })
        )
      );
    }
  }]);

  return RadioSelectable;
}(_react2.default.Component);

var styles = function styles(theme) {
  return {
    container: {
      background: '#f4f4f4',
      padding: '0px 10px',
      marginBottom: theme.spacing.unit * 2
    },
    label: {
      marginBottom: 0
    },
    root: {
      '&$checked': {
        color: theme.palette.primary.main
      }
    },
    checked: {}
  };
};

RadioSelectable.propTypes = {
  options: _propTypes2.default.array.isRequired,
  classes: _propTypes2.default.object.isRequired,
  input: _propTypes2.default.object.isRequired,
  disabled: _propTypes2.default.bool
};

RadioSelectable.defaultProps = {
  disabled: false
};

exports.default = (0, _materialUi.withStyles)(styles)(RadioSelectable);